module.exports = __webpack_public_path__ + "media/images/mobile/solutions/21-2d2e5cdf7f63dcc90d215a395bfbd5fa.jpg";